import React from "react";
import styled from "styled-components";

const Loading = ({ opacity }) => {
  return (
    <LoadingContainer opacity={opacity}>
      <StyledLoadingIcon></StyledLoadingIcon>
    </LoadingContainer>
  );
};

export default Loading;

const LoadingContainer = styled.div.attrs((props) => ({
  opacity: props.opacity || 1,
}))`
  opacity: ${(props) => props.opacity};
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const StyledLoadingIcon = styled.div`
  border: 5px solid #ccc;
  border-top: 5px solid #eee;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: button-keyframe-spin 1s linear infinite;
  box-sizing: initial !important;

  @keyframes button-keyframe-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
